// Session-only enrollment path context. No customer identifiers or network calls.
(function () {
  'use strict';
  var CLICK_KEY = 'hs_tfs_discovery_click';
  var LANDING_KEY = 'hs_tfs_enrollment_landing';
  var handlePattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

  function read(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function write(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) {}
  }
  function validLanding(value) {
    return value === 'khub-discover' || /^email:[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value || '');
  }
  function handleFrom(url) {
    try {
      var parsed = new URL(url, window.location.href);
      if (parsed.origin !== window.location.origin) return null;
      var match = /^\/products\/([a-z0-9]+(?:-[a-z0-9]+)*)\/?$/.exec(parsed.pathname);
      return match ? match[1] : null;
    } catch (e) { return null; }
  }
  function record(surface, url) {
    if (surface !== 'wheel') return;
    var handle = handleFrom(url);
    if (handle && handlePattern.test(handle)) write(CLICK_KEY, JSON.stringify({ surface: surface, handle: handle }));
  }
  function source() {
    var landing = read(LANDING_KEY);
    if (validLanding(landing)) return landing;
    try {
      var click = JSON.parse(read(CLICK_KEY) || 'null');
      if (click && click.surface === 'wheel' && handlePattern.test(click.handle)) return 'wheel';
    } catch (e) {}
    return 'tfs-page';
  }

  if (/^\/pages\/(?:my-tea-collection|tea-flight-shuffle)\/?$/.test(window.location.pathname)) {
    var fromUrl = new URLSearchParams(window.location.search).get('src');
    if (validLanding(fromUrl)) write(LANDING_KEY, fromUrl);
  }
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var wheel = target.closest('#hsCardCta');
    if (wheel) { record('wheel', wheel.href); return; }
  }, true);
  window.hsEnrollmentSource = { get: source };
}());
